import { useEffect } from "react";

import {
  isDescriptorInsideCourse,
  useCourseRevisionNavigationInterceptor,
  useCourseRevisionState,
} from "@pm2/course-revisions";
import { findPageDescriptorByPath, pm2SitemapStore } from "@pm2/sitemap-utils";
import { useLocation } from "@provider/navigation";

export function UseCourseRevisionSideEffects() {
  const sitemapState = pm2SitemapStore.useSelector((state) => state);
  const location = useLocation();
  const currentDescriptor = findPageDescriptorByPath(
    sitemapState,
    location.pathname,
  );

  const isEditing = useCourseRevisionState((state) => state.isEditing);
  useCourseRevisionNavigationInterceptor();

  useEffect(() => {
    document.body.classList.toggle(
      "isEditingRevision",
      isEditing && isDescriptorInsideCourse(sitemapState, currentDescriptor),
    );
  }, [currentDescriptor, isEditing, sitemapState]);

  return null;
}
